class Navbar extends HTMLElement {
  constructor () {
    super()

    this.handleDropdownsBackdrop()
    this.handleHeaderReveal()
    this.adjustMobileMenu()
    this.adjustDesktopMenu()
  }

  adjustMobileMenu () {
    const offcanvas = document.querySelector('#offcanvas-mobile-menu')
    const navbarMobile = document.querySelector('#navbar-mobile')

    offcanvas?.addEventListener('show.bs.offcanvas', () => {
      const navbarSpacing = document.querySelector('#navbar-mobile').getBoundingClientRect().bottom
      offcanvas.style.height = `${window.innerHeight - navbarSpacing}px`

      navbarMobile.querySelector('.svg-icon-menu')?.classList.add('svg-icon-menu-close')
    })

    offcanvas?.addEventListener('hide.bs.offcanvas', () => {
      navbarMobile.querySelector('.svg-icon-menu')?.classList.remove('svg-icon-menu-close')
    })
  }

  adjustDesktopMenu () {
    const dropdown = document.querySelector('.navbar-megamenu-dropdown')
    const navbarDesktop = document.querySelector('#navbar-desktop')
    const toggler = navbarDesktop.querySelector('.navbar-megamenu-dropdown [data-bs-toggle="dropdown"]')

    dropdown?.addEventListener('show.bs.dropdown', () => {
      console.log('show')
      document.body.classList.add('megamenu-is-open')
      toggler.textContent = toggler.dataset.textClose
    })

    dropdown?.addEventListener('hide.bs.dropdown', () => {
      console.log('hide')
      document.body.classList.remove('megamenu-is-open')
      toggler.textContent = toggler.dataset.textMenu
    })
  }

  handleHeaderReveal () {
    let oldScroll = window.scrollY
    const headerGroup = document.querySelector('#header-group')

    window.addEventListener('scroll', () => {
      const newScroll = window.scrollY
      if (newScroll > oldScroll) {
        if (newScroll > headerGroup.clientHeight) {
          headerGroup.classList.add('hide')
        }
      } else if (newScroll < oldScroll) {
        headerGroup.classList.remove('hide')
      }

      oldScroll = Math.max(window.scrollY, 0)
    })
  }

  handleDropdownsBackdrop () {
    this.querySelectorAll('#navbar-desktop .dropdown-toggle').forEach(dropdown => {
      dropdown.addEventListener('hidden.bs.dropdown', () => {
        if (!document.querySelector('#navbar-desktop .dropdown-toggle.show')) {
          document.body.classList.remove('navbar-dropdown-open')
        }
      })
      dropdown.addEventListener('show.bs.dropdown', () => {
        document.body.classList.add('navbar-dropdown-open')
      })
    })
  }
}
customElements.define('navbar-wrapper', Navbar)

class MarqueeSection extends HTMLElement {
  constructor () {
    super()

    this.init()

    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId === this.dataset.sectionId) {
        this.init()
      }
    })
  }

  init () {
    const list = this.querySelector('ul')

    const marqueeWidth = list.scrollWidth
    const marqueeLength = list.querySelectorAll('li').length

    list.insertAdjacentHTML('beforeEnd', list.innerHTML)
    list.insertAdjacentHTML('beforeEnd', list.innerHTML)

    list.querySelectorAll('li').forEach((item, index) => {
      if (index >= marqueeLength) {
        item.setAttribute('aria-hidden', 'true')
      }
    })

    let style = `
      <style>
        #marquee-${this.dataset.sectionId} .marquee-list {
          animation-name: marquee_animation_${this.dataset.sectionId};
          animation-duration: ${this.dataset.marqueeDuration}s;
        }
        @keyframes marquee_animation_${this.dataset.sectionId} {
          to { transform: translateX(-${marqueeWidth}px); }
        }
      </style>
    `
    if (this.dataset.marqueeDirection === 'right') {
      style += `
        <style>
          @keyframes marquee_animation_${this.dataset.sectionId} {
            from { transform: translateX(-${marqueeWidth}px); }    
            to { transform: 0); }    
          }
        </style>
      `
    }

    this.insertAdjacentHTML('beforeBegin', style)
  }
}
customElements.define('marquee-section', MarqueeSection)

class NewsletterPopup extends HTMLElement {
  constructor () {
    super()

    if (window.Shopify.designMode) return

    if (window.location.href.includes('newsletter-popup')) {
      window.bootstrap.Modal.getOrCreateInstance(this).show()
      return
    }

    if (document.cookie.indexOf('newsletter-popup') > -1) {
      return
    };

    (async () => {
      await new Promise(resolve => setTimeout(resolve, Number(this.dataset.configDelay) * 1000))
      window.theme.createCookie('newsletter-popup', true, Number(this.dataset.configDaysToWait))
      window.bootstrap.Modal.getOrCreateInstance(this).show()
    })()
  }
}
customElements.define('newsletter-popup', NewsletterPopup)

class HeroSlider extends HTMLElement {
  constructor () {
    super()

    this.init()

    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId === this.dataset.sectionId) {
        this.init()
      }
    })
  }

  init () {
    this.slider = new window.Swiper(this, {
      speed: this.speed,
      autoplay: this.autoplay,
      navigation: this.navigation,
      pagination: this.pagination,
      breakpoints: this.breakpoints,
      loop: true,
      centeredSlides: true
    })
  }

  speed = Number(this.dataset.sliderSpeed)

  autoplay = this.dataset.sliderAutoplay === '0'
    ? undefined
    : { delay: Number(this.dataset.sliderAutoplay) * 1000 }

  navigation = {
    enabled: this.dataset.sliderNavigation === 'true',
    prevEl: '.swiper-button-prev',
    nextEl: '.swiper-button-next'
  }

  pagination = {
    enabled: this.dataset.sliderPagination === 'true',
    el: '.swiper-pagination',
    type: 'bullets',
    dynamicBullets: true,
    dynamicMainBullets: 2
  }

  breakpoints = {
    0: { slidesPerView: 1 },
    600: { slidesPerView: 1 },
    1200: { slidesPerView: 3 }
  }
}
customElements.define('hero-slider', HeroSlider)

class TikTokSlider extends HTMLElement {
  constructor () {
    super()

    this.videos = this.querySelectorAll('video')

    this.videos.forEach(video => {
      video.addEventListener('click', () => { this.onVideoClick(video) })
    })

    this.closest('.swiper').swiper.on('slideChange', () => {
      this.videos.forEach(video => {
        video.pause()
        video.closest('.video-wrapper').classList.remove('is-playing')
      })
    })
  }

  onVideoClick (video) {
    this.videos.forEach(video2 => {
      if (video2.dataset.index !== video.dataset.index) {
        video2.pause()
        video2.closest('.video-wrapper').classList.remove('is-playing')
      }
    })

    console.log(video.closest('.video-wrapper').classList.contains('is-playing'))

    if (video.closest('.video-wrapper').classList.contains('is-playing')) {
      video.pause()
      video.closest('.video-wrapper').classList.remove('is-playing')
    } else {
      video.play()
      video.closest('.video-wrapper').classList.add('is-playing')
    }
  }
}
customElements.define('tiktok-slider', TikTokSlider)

class ImageCompareSection extends HTMLElement {
  constructor () {
    super()

    new window.ImageCompare(this, {
      addCircle: true,
      smoothing: false
    }).mount()
  }
}
customElements.define('image-compare-section', ImageCompareSection)
